// グローバルに使いたいモジュール,関数はこちらで定義
// 残りはcomponents配下に配置してバンドルする方向性
$(function () {
	var params = getParameter();
	if (params['entry'] !== '') {
		console.log(decodeURIComponent(params['entry']));
		$("#contact_form_99").val(decodeURIComponent(params['entry']));
	}

	function getParameter() {
		var paramsArray = [];
		var url = location.href;
		parameters = url.split("#");
		if (parameters.length > 1) {
			url = parameters[0];
		}
		parameters = url.split("?");
		if (parameters.length > 1) {
			var params = parameters[1].split("&");
			for (i = 0; i < params.length; i++) {
				var paramItem = params[i].split("=");
				paramsArray[paramItem[0]] = paramItem[1];
			}
		}
		return paramsArray;
	};
})
